<template>
  <div class="page">
    <div class="layout">
      <el-row>
        <el-col :span="24">
          <div class="page-title">數據字典</div>
        </el-col>
      </el-row>
      <div @click="onClicked" class="item">課題範圍</div>
    </div>
  </div>
</template>

<script>
export default {
  components: {},
  data() {
    return {
     
    };
  },
  created() {},
  methods: {
    onClicked() {
      this.$router.push({ path: "/dataDictionary/programmeTypeList" });
    },
  },
};
</script>

<style lang="scss" scoped>
.page {
  .layout {
    .el-row {
      margin-bottom: 20px;
      &:last-child {
        margin-bottom: 0;
      }

      .title {
        font-size: 30px;
      }
    }

    .item {
      color: #004eff;
      cursor: pointer;
      font-size: 20px;
    }
  }
}
</style>